import { CMBS_SECTOR_ID } from './constants';

class Sector {
  static isCmbsSectorId(sectorId: string): boolean {
    return sectorId === CMBS_SECTOR_ID;
  }
}

export default Sector;
